import { SortingFnOption } from '@tanstack/react-table';
import { OrganisationMember } from 'PublicEntityTypes';
import { AvatarNameDescription } from '../../../design-system/avatar/avatar-name-description/avatar-name-description';
import { Badge } from '../../../design-system/badge/badge';

export const inviteStatusSortFn: SortingFnOption<OrganisationMember> = (rowA, rowB) => {
  const statusA = rowA.original.status;
  const statusB = rowB.original.status;

  if (statusA === 'INVITE_PENDING' && statusB !== 'INVITE_PENDING') return -1;
  if (statusA !== 'INVITE_PENDING' && statusB === 'INVITE_PENDING') return 1;
  return 0;
};

export const getMemberCell = (
  email: string,
  firstName: string,
  lastName: string,
  pictureUrl?: string,
): React.ReactNode | null => {
  if (!firstName || !lastName) {
    return <AvatarNameDescription avatar={{ showAvatar: true, avatarUrl: pictureUrl }} name={email} />;
  }
  return (
    <AvatarNameDescription
      avatar={{ showAvatar: true, avatarUrl: pictureUrl }}
      name={`${firstName} ${lastName}`}
      description={email}
    />
  );
};

export const getRoleCell = (role: string): React.ReactElement => {
  switch (role) {
    case 'admin':
      return <Badge variant="neutral">Admin</Badge>;
    default:
      // TODO: The API doesn't return the role of members and currently all users are admins so we can hardcode this for now
      return <Badge variant="neutral">Admin</Badge>;
  }
};

export const getInviteStatusCell = (
  status: string,
  email: string,
  loggedInUserEmail?: string,
): React.ReactElement | null => {
  if (loggedInUserEmail === email) {
    return null;
  }
  if (status === 'INVITE_PENDING') {
    return <p className="text-right text-seapoint-gray-text">Invite pending</p>;
  }
  if (status === 'ACTIVE') {
    return <p className="text-right text-seapoint-gray-text">Active</p>;
  }
  return null;
};
